import { InjectionToken } from '@angular/core';

export interface ModalWindowConfig {
    animatePopupDismiss?: boolean;
    showCloseIcon?: boolean;
}

export const MODAL_WINDOW_CONFIG = new InjectionToken<ModalWindowConfig>('MODAL_WINDOW_CONFIG');
